import { secretKey } from '../../Enum/SecretKey';

var CryptoJS = require("crypto-js");
export const encrypt = data => CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
